import { createClientFeaturesForEnv } from '@ip-only/client-features';
import { availableClientFeatures } from './available-client-features';

export const clientFeatures = createClientFeaturesForEnv(
  availableClientFeatures,
  {
    fiberModule: true,
    servicesModule: true,
    cookieBotGoogleAnalytics: false,
    addressSearchModule: true,
    bankId: true,
    translations: true,
    vacationHomesServices: true,
    fiberOrderWithPartialPayment: false,
    footer: true,
  }
);
